import Component from '../core/Component'
import PhotoSlider, { EMITS as PHOTOSLIDER_EMITS} from './PhotoSlider'
import ThumbnailList, { EMITS as THUMBNAILLIST_EMITS} from './ThumbnailList'
import { CMS } from '../core/config'

export const STATES = {
    CONTENT_OPEN: 'is-open-content',
    VISIBLE: 'is-visible',
    ENTERING: 'is-entering',
    LEAVING: 'is-leaving',
    ACTIVE: 'is-active',
    READY: 'is-ready'
}

export const EMITS = {
    CHANGE: 'changed'
}

export default class ToggleShowContent extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            toggles: [],
            content: null
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        this.ref.toggles.forEach(toggle => toggle.addEventListener('click', this.handleToggle))

        this.element.addEventListener('transitionend', this.handleTransitionEnd)

        this.element.classList.add(STATES.READY)
    }

    handleToggle = event => {
        this.toggleContent()
    }

    openContent() {
        if (this.is(STATES.CONTENT_OPEN)) {
            return
        }

        this.ref.content.style.maxHeight = `${this.ref.content.scrollHeight}px`
        this.element.classList.add(STATES.CONTENT_OPEN)
        this.thumbnailList?.expand()
        this.emit(EMITS.CHANGE)
    }

    closeContent() {
        if (!this.is(STATES.CONTENT_OPEN)) {
            return
        }

        this.ref.content.style.maxHeight = null
        this.element.classList.remove(STATES.CONTENT_OPEN)
        this.thumbnailList?.collapse()
        this.emit(EMITS.CHANGE)
    }

    toggleContent() {
        if (this.is(STATES.CONTENT_OPEN)) {
            this.closeContent()
        } else {
            this.openContent()
        }
    }

    hide() {
        this.element.classList.add(STATES.LEAVING)
        this.element.classList.remove(STATES.ENTERING)
        this.element.classList.remove(STATES.ACTIVE)

        if (this.is(STATES.LEAVING) || !this.is(STATES.ACTIVE)) {
            return
        }

        this.element.classList.add(STATES.LEAVING)
    }

    show() {
        this.element.classList.remove(STATES.LEAVING)
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ENTERING)
        this.photoSlider?.resize()

        if (this.is(STATES.ENTERING) || this.is(STATES.ACTIVE)) {
           return
        }
    }

    handleTransitionEnd = event => {
        if (event.target !== this.element) {
            return
        }

        if (this.is(STATES.ENTERING)) {
            this.element.classList.add(STATES.ACTIVE)
            this.element.classList.remove(STATES.ENTERING)
        }

        if (this.is(STATES.LEAVING)) {
            this.element.classList.remove(STATES.LEAVING)
            this.element.classList.remove(STATES.VISIBLE)
        }

    }
}

